export default __webpack_public_path__ + "static/media/Wordpress_Woojobz_Job_Portal.6babb1a4.png";